module.exports = __webpack_public_path__ + "img/1.589f4c4a.png";